import { PageHeader } from '@/components/layout/PageHeader'

export default function ReportsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Reports" description="View analytics and reports" />
      <div className="text-muted-foreground">Reports content coming soon...</div>
    </div>
  )
}
